import { H1 } from 'components/Text';
import Container from 'components/Container';
import markdownStyles from 'styles/Markdown.module.css';
import { PAGE_TITLE, PAGE_TOP, PAGE_BOTTOM, TEXT_COLUMN } from './pageLayout';
import { renderMarkdown } from './renderMarkdown';

interface ITextPageProps {
  title: string;
  content?: string | null;
}

// About us, Contact, FAQ, Careers, Privacy and Terms: a title and the page's
// markdown in one centred reading column (WHIT-469).
const TextPage: React.FC<ITextPageProps> = ({ title, content }) => (
  <Container>
    <div className={`${TEXT_COLUMN} ${PAGE_TOP} ${PAGE_BOTTOM}`}>
      <H1 gopher className={`mb-6 ${PAGE_TITLE}`}>
        {title === '' ? 'No translation was found' : title}
      </H1>
      {content && (
        <div
          className={markdownStyles['markdown-body']}
          dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }}
        />
      )}
    </div>
  </Container>
);

export default TextPage;
